import styled from "@emotion/styled"
import { NewText } from "ui"

const StyledTextContent = styled.div<{
  isCentered?: boolean
  desktopMarginBottom?: number
  mobileMarginBottom?: number
  mobileGap?: number
  desktopGap?: number
}>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.mobileGap || 8}px;
  text-align: ${(props) => (props.isCentered ? "center" : "initial")};
  color: var(--benefits-black);
  margin-bottom: ${(props) => props.mobileMarginBottom || 0}px;

  font-family: var(--heading-font, var(--narkis-condensed)) !important;
  * {
    font-family: inherit !important;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: ${(props) => props.desktopGap || 16}px;
    margin-bottom: ${(props) => props.desktopMarginBottom || 0}px;
  }
`

const StyledHeading = styled.h2<{ isCentered?: boolean }>`
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: 40px;
  font-weight: 400;
  line-height: 120%;
  text-align: ${(props) => (props.isCentered ? "center" : "initial")};

  > * {
    margin: 0;
    padding: 0;
    gap: 8px;
  }

  table:not(.MuiTable-root) {
    font-family: var(--narkis) !important;
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
  }
  table:not(.MuiTable-root) td,
  table:not(.MuiTable-root) th {
    font-family: var(--narkis) !important;
  }

  strong {
    color: ${(props) => props.theme.colors.blue4rentMarketing};
    display: inline-block;
    margin: 0;
    position: relative;
    font-weight: 700;
    &::after {
      content: "";
      background-image: url("/icons/heading-underline-blue-mobile.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position: absolute;
      bottom: -4px;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 4px;
      z-index: 1;
    }
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 60px;
    font-weight: 400;
    line-height: 150%;
    strong {
      font-weight: 700;
      &::after {
        background-image: url("/icons/heading-underline-blue-desktop.svg");
      }
    }
  }
`

const StyledP = styled(NewText)<{ $paddingMobile?: string; $paddingDesktop?: string }>`
  margin: 0;
  padding: ${(p) => p.$paddingMobile || 0};
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(p) => p.$paddingDesktop || 0};
    letter-spacing: -0.48px;
  }
  font-family: var(--narkis) !important;
  * {
    margin: 0;
  }
`

type Props = {
  id?: string
  title?: string
  subTitle?: string
  isCentered?: boolean
  desktopMarginBottom?: number
  mobileMarginBottom?: number
  isSubTitleRichText?: boolean
  titleCls?: string
  desktopGap?: number
  mobileGap?: number
  className?: string
  subTitleFontWeight?: number
  subTitlePaddingMobile?: string
  subTitlePaddingDesktop?: string
}

const WhiteBgHeading = ({
  id,
  title,
  subTitle,
  isCentered = true,
  desktopMarginBottom,
  mobileMarginBottom,
  isSubTitleRichText = false,
  titleCls = "",
  desktopGap,
  mobileGap,
  className,
  subTitleFontWeight,
  subTitlePaddingMobile,
  subTitlePaddingDesktop,
}: Props) => {
  return (
    <StyledTextContent
      isCentered={isCentered}
      desktopMarginBottom={desktopMarginBottom}
      mobileMarginBottom={mobileMarginBottom}
      mobileGap={mobileGap}
      desktopGap={desktopGap}
      className={className}
    >
      {title && (
        <StyledHeading
          {...(id && { id })}
          className={titleCls}
          isCentered={isCentered}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      )}
      {subTitle &&
        (isSubTitleRichText ? (
          <StyledP
            className={titleCls}
            component="p"
            $paddingMobile={subTitlePaddingMobile}
            $paddingDesktop={subTitlePaddingDesktop}
            desktopFontSize={24}
            mobileFontSize={20}
            desktopLineHeight={"32px"}
            mobileLineHeight="130%"
            inheritColor
            color="inherit"
            desktopFontWeight={subTitleFontWeight || 400}
            dangerouslySetInnerHTML={{ __html: subTitle }}
          />
        ) : (
          <StyledP
            className={titleCls}
            component="p"
            $paddingMobile={subTitlePaddingMobile}
            $paddingDesktop={subTitlePaddingDesktop}
            desktopFontSize={24}
            mobileFontSize={20}
            desktopLineHeight={"150%"}
            mobileLineHeight="130%"
            inheritColor
            color="inherit"
            desktopFontWeight={subTitleFontWeight || 400}
          >
            {subTitle}
          </StyledP>
        ))}
    </StyledTextContent>
  )
}
export default WhiteBgHeading
